import Promise from 'bluebird'

import facebookLib from 'lib/facebook'
import integrationsLib from 'lib/integrations'
import trackService from 'api/track'
import store from 'src/store'
import TRACKING_EVENTS from 'constants/trackingEvents'

const FbqEvents = {
  AddToCart: 'AddToCart',
  InitiateCheckout: 'InitiateCheckout',
  Purchase: 'Purchase',
}

const TrackingEventsToFbqEvents = {
  [TRACKING_EVENTS.AddedItemToCart]: FbqEvents.AddToCart,
  [TRACKING_EVENTS.StartedCheckout]: FbqEvents.InitiateCheckout,
  [TRACKING_EVENTS.BookingCompleted]: FbqEvents.Purchased,
}

export default {
  init(venue) {
    if (!venue) throw new Error('venue required for analytics')

    if (venue.trackingFacebookPixelId) {
      facebookLib.init(venue.trackingFacebookPixelId)
    }
  },
  pageView() {
    integrationsLib.pageView().then(() => {
      return null
    })

    const venue = store.state.venue.current

    if (venue && venue.trackingFacebookPixelId) {
      facebookLib.track(venue.trackingFacebookPixelId, 'fb_page_view', {
        venueId: venue.id,
        venueName: venue.name,
      })
    }
  },
  async trackEvent(event, data) {
    if (!event) throw new Error('event')
    if (!data) throw new Error('data')

    window.analytics.track(event, data)

    const venue = store.state.venue.current

    if (venue && venue.trackingFacebookPixelId) {
      const fbqEvent = TrackingEventsToFbqEvents[event]
      const fbqEventData = undefined

      if (fbqEvent) {
        if (fbqEvent === FbqEvents.Purchase) {
          fbqEventData = {
            value: data.total,
            currency: data.currency,
          }
        }

        facebookLib.track(venue.trackingFacebookPixelId, fbqEvent, fbqEventData)
      }
    }

    return Promise.all([
      integrationsLib.track(event, data),
      // trackService.send(event, data)
    ])
      .then(() => {
        return null
      })
      .catch((err) => {
        console.log('error tracking', err) //eslint-disable-line

        return null
      })
  },
}



// WEBPACK FOOTER //
// ./src/lib/analytics.js